import PropTypes from "prop-types";

import HelpIcon from "@mui/icons-material/Help";
import { Paper, Stack, Tooltip, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";

import { formatDate, formatDateTime, formatMoney } from "../../../shared";
import {
  salesOrderStatusColors,
  salesOrderStatusLabels,
} from "../../sales-order-status";

export const TransactionInformationSection = ({ salesOrder }) => {
  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="subtitle1">Informasi Transaksi</Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <Typography variant="caption">Tanggal Transaksi</Typography>
          <Typography>{formatDate(salesOrder.transactionDate)}</Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <Typography variant="caption">Dibuat pada</Typography>
          <Typography>{formatDateTime(salesOrder.createdAt)}</Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <Typography variant="caption">Dibuat oleh</Typography>
          <Typography>{salesOrder.creator?.name}</Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <Typography variant="caption">Pelanggan</Typography>
          <Typography>{salesOrder.buyer?.name ?? "-"}</Typography>
          {salesOrder.buyer?.phoneNumbers?.length > 0 && (
            <Typography variant="body2" sx={{
              color: "text.secondary"
            }}>
              {salesOrder.buyer.phoneNumbers
                .map((p) => `+${p.dialCode}${p.number}`)
                .join(", ")}
            </Typography>
          )}
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <Typography variant="caption">Cabang</Typography>
          <Typography>{salesOrder.seller.name}</Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <Typography variant="caption">Gudang</Typography>
          <Typography>{salesOrder.warehouse?.name ?? "-"}</Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <Typography variant="caption">Subtotal</Typography>
          <Typography>{formatMoney(salesOrder.subtotal)}</Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <Typography variant="caption">Total Diskon</Typography>
          <Typography>{formatMoney(salesOrder.totalDiscount)}</Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <Typography variant="caption">Grand Total</Typography>
          <Typography color={"primary"} sx={{
            fontWeight: "bold"
          }}>
            {formatMoney(salesOrder.grandTotal)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <Typography variant="caption">Uang Muka Tersedia</Typography>
          <Typography>
            {formatMoney(salesOrder.availableDownPaymentAmount ?? 0)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <Typography variant="caption">Status</Typography>
          <Stack direction="row" spacing={1} sx={{
            alignItems: "center"
          }}>
            <Typography color={salesOrderStatusColors[salesOrder.status]}>
              {salesOrderStatusLabels[salesOrder.status]}
            </Typography>
            {salesOrder.salesOrderVoidance && (
              <Tooltip
                title={
                  salesOrder.salesOrderVoidance.reason +
                  " (oleh " +
                  salesOrder.salesOrderVoidance.user.name +
                  ")"
                }
              >
                <HelpIcon sx={{ fontSize: "medium", color: "grey" }} />
              </Tooltip>
            )}
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <Typography variant="caption">Syarat Pembayaran</Typography>
          <Typography>{salesOrder.paymentTerm?.name}</Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

TransactionInformationSection.propTypes = {
  salesOrder: PropTypes.object.isRequired,
};
